"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CwTriggerField = _interopRequireDefault(require("./CwTriggerField.scss"));

var _CwTextField = _interopRequireDefault(require("../cwtextfield/CwTextField"));

var _CwImage = _interopRequireDefault(require("../cwimage/CwImage"));

var _classnames = _interopRequireDefault(require("classnames"));

var _IconPath = _interopRequireDefault(require("../../utils/IconPath"));

var CwTriggerField =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(CwTriggerField, _React$Component);

  function CwTriggerField() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, CwTriggerField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(CwTriggerField)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleTrigger", function () {
      if (_this.props.disabled) return;

      if (_this.props.onTrigger) {
        _this.props.onTrigger();
      }

      _this.focus();
    });
    return _this;
  }

  (0, _createClass2.default)(CwTriggerField, [{
    key: "focus",
    value: function focus() {
      this.cwTextField.focus();
    }
  }, {
    key: "render",
    value: function render() {
      var _cx,
          _this2 = this;

      var triggerClass = (0, _classnames.default)((_cx = {}, (0, _defineProperty2.default)(_cx, this.props.className, this.props.className), (0, _defineProperty2.default)(_cx, _CwTriggerField.default.triggerField, _CwTriggerField.default.triggerField), (0, _defineProperty2.default)(_cx, _CwTriggerField.default.triggerFieldSpace, this.props.customElement), _cx));
      var customElementClass = this.props.customElement ? this.props.customElementClassName ? this.props.customElementClassName : _CwTriggerField.default.customElement : null;
      var triggerStyle = _CwTriggerField.default.trigger;
      if (this.props.disabled) triggerStyle = _CwTriggerField.default.triggerDisabled;else if (this.props.invalid) triggerStyle = _CwTriggerField.default.triggerInvalid;
      return _react.default.createElement("div", {
        className: triggerClass
      }, this.props.customElement ? _react.default.createElement("div", {
        className: customElementClass
      }, this.props.customElement) : null, _react.default.createElement(_CwTextField.default, {
        cwId: this.props.cwId,
        autoComplete: "off",
        ref: function ref(input) {
          return _this2.cwTextField = input;
        },
        onFocus: this.props.onFocus,
        onBlur: this.props.onBlur,
        onChange: this.props.onChange,
        onKeyDown: this.props.onKeyDown,
        onKeyUp: this.props.onKeyUp,
        value: this.props.value,
        disabled: this.props.disabled,
        invalid: this.props.invalid,
        readOnly: this.props.readOnly,
        autoFocus: this.props.autoFocus,
        regex: this.props.regex,
        maxLength: this.props.maxLength,
        placeholder: this.props.placeholder
      }), _react.default.createElement(_CwImage.default, {
        cwId: "".concat(this.props.cwId, "_image"),
        className: triggerStyle,
        src: this.props.triggerIcon,
        height: 24,
        width: 24,
        onClick: this.handleTrigger
      }));
    }
  }]);
  return CwTriggerField;
}(_react.default.Component);

CwTriggerField.propTypes = {
  /**
   * Connectwise element id to be used as unique identifier
   */
  cwId: _propTypes.default.string,

  /**
   * Path to trigger icon
   */
  triggerIcon: _propTypes.default.string,

  /**
   * Callback function that is fired on trigger field keydown
   */
  onKeyDown: _propTypes.default.func,

  /**
   * Callback function that is fired when trigger field's text changes
   */
  onChange: _propTypes.default.func,

  /**
   * Callback function that is fired on trigger field keyup
   */
  onKeyUp: _propTypes.default.func,

  /**
   * Callback function that is fired on trigger field focus
   */
  onFocus: _propTypes.default.func,

  /**
   * Callback function that is fired on trigger field blur
   */
  onBlur: _propTypes.default.func,

  /**
   * Callback function that is fired when trigger is clicked on
   */
  onTrigger: _propTypes.default.func,

  /**
   * Used to control if trigger field is valid
   */
  invalid: _propTypes.default.bool,

  /**
   * Used to disable trigger field
   */
  disabled: _propTypes.default.bool,

  /**
   * Text in textfield
   */
  value: _propTypes.default.any,

  /**
   * Used to add custom css
   */
  className: _propTypes.default.string,

  /**
   * Used to set input field to readonly
   */
  readOnly: _propTypes.default.bool,

  /**
   * Used to control if input field is autofocused when the page loads
   */
  autoFocus: _propTypes.default.bool,

  /**
   * Used to add a custom element to the left side of the trigger field
   */
  customElement: _propTypes.default.any,

  /**
   * Used to add custom css to a custom element on the left side of the trigger field
   */
  customElementClassName: _propTypes.default.any,

  /**
   * Used to limit the inputs of the field by matching against provided string.
   */
  regex: _propTypes.default.string,

  /**
   * The maximium number of characters allowed in the field.
   */
  maxLength: _propTypes.default.number,

  /**
   * Hint text, displayed when user has not typed anything in
   */
  placeholder: _propTypes.default.string
};
CwTriggerField.defaultProps = {
  triggerIcon: _IconPath.default.get('Action_ExpandDown')
};
var _default = CwTriggerField;
exports.default = _default;